<template>
    <section class="bg-red pb-8 pt-[60px] text-white at1024:overflow-x-clip at1024:overflow-y-visible at1024:pb-28 at1024:pt-[90px] at1024:relative">
        <div class="wrap wrap-large at1024:relative at1024:z-10">
            <div class="text-center at1024:text-left at1024:w-[550px]">
                <h1 class="font-bold leading-[0.9em] text-[40px] uppercase at1024:text-[120px]">Open the Door to More</h1>
                <h2 class="leading-tight mt-2 text-[28px] at1024:max-w-[80%] at1024:mt-0 at1024:text-[35px]">Our West Coast Distribution Center has expanded!</h2>
            </div>
        </div>
        <img src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/westcoast_banner" class="block max-w-[954px] mt-7 mx-auto w-[90%] at1024:absolute at1024:left-[44%] at1024:top-0 at1024:w-auto" height="615" width="954" sizes="954px" alt="A peek into a warehouse via red open doors">
    </section>
    <section class="pb-[90px] pt-10 relative overflow-x-clip at1024:pb-44 at1024:pt-[120px]">
        <img src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/westcoast_direction_bottom" class="block ml-[49%]" height="313" width="1300" sizes="1300px" alt="" aria-hidden="true">
        <div class="wrap wrap-large max-w-[660px] at480:-mt-10 at1200:-mt-28">
            <div class="pt-8 text-center at1024:pt-2">
                <h3 class="leading-[1.1em] mb-4 text-[30px] at1024:text-[60px]">We stock the deepest and widest inventory.</h3>
                <p class="leading-[1.2em] text-[28px] text-gray at1024:text-[35px]">Our new, <em>much larger</em>, facility is fully stocked with the industry’s premium brands; find every part, product, or accessory item on our shelves, ready to be shipped the same day they’re ordered.</p>
            </div>
        </div>
    </section>
    <section class="bg-gray-120 pb-24 pt-[60px] at1024:pb-32 at1024:pt-[90px]">
        <div class="max-w-[660px] wrap wrap-large">
            <h3 class="font-bold leading-[1.1em] mb-8 text-[30px] at1024:mb-[60px] at1024:text-5xl">How does SECLOCK serve you better?</h3>
            <ul class="grid gap-9 at1024:gap-12 at1024:grid-cols-3 at1200:gap-[53px]">
                <li>
                    <span class="block font-bold mb-[10px] text-red uppercase">Inventory</span>
                    <h4 class="font-bold leading-tight mb-[10px] text-[28px] at1024:text-[35px]">One-Stop Source</h4>
                    <p class="text-gray">Source everything from hard-to-find parts to mainstream products in every finish, function, design, length, voltage, and option.</p>
                </li>
                <li>
                    <span class="block font-bold mb-[10px] text-red uppercase">Delivery</span>
                    <h4 class="font-bold leading-tight mb-[10px] text-[28px] at1024:text-[35px]">Quick Shipping</h4>
                    <p class="text-gray">The part that matters most is the one you need right now — that’s why most orders ship the same day they’re ordered.</p>
                </li>
                <li>
                    <span class="block font-bold mb-[10px] text-red uppercase">Expertise</span>
                    <h4 class="font-bold leading-tight mb-[10px] text-[28px] at1024:text-[35px]">Technical Support</h4>
                    <p class="text-gray">No matter what you encounter on the job, we have field-experienced experts waiting to help you find the right solution.</p>
                </li>
            </ul>
        </div>
    </section>
    <section class="pt-[60px] at1024:pt-[90px]">
        <div class="wrap wrap-large">
            <div class="text-center">
                <h3 class="leading-[1.1em] mb-4 text-[30px] at1024:text-[60px]">Source the brands you know and trust.</h3>
                <p class="leading-[1.2em] text-[28px] text-gray at1024:text-[35px]">From A to Z, we stock every premium manufacturer in the industry including Allegion, ASSA ABLOY, dormakaba, and more.</p>
            </div>
            <ul class="grid at1024:gap-[60px] at1024:grid-cols-3">
                <li>
                    <img src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/westcoast_algn" class="block max-w-[200px] mx-auto at1024:max-w-full" height="197" width="293" sizes="293px" alt="The official Allegion logo">
                </li>
                <li>
                    <img src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/westcoast_assa" class="block max-w-[200px] mx-auto at1024:max-w-full" height="197" width="293" sizes="293px" alt="The official ASSA ABLOY logo">
                </li>
                <li>
                    <img src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/westcoast_doko" class="block max-w-[200px] mx-auto at1024:max-w-full" height="197" width="293" sizes="293px" alt="The official dormakaba logo">
                </li>
            </ul>
        </div>
    </section>
    <section class="pb-[72px] pt-[60px] overflow-x-clip at1024:pt-5">
        <div class="aspect-[1300/341] max-h-[341px] relative at1350:aspect-auto at1350:h-[341px]">
            <img src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/westcoast_direction_top" class="absolute block right-[49%] top-0" height="341" width="1300" sizes="1300px" alt="" aria-hidden="true">
        </div>
        <div class="wrap wrap-large max-w-[660px]">
            <div class="pt-6 text-center at1024:pt-16 at1350:pt-2">
                <h3 class="font-bold leading-[1.1em] mb-4 text-[30px] at1024:text-[60px]">Our new address:</h3>
                <p class="leading-[1.2em] mb-[30px] text-[28px] text-gray at1024:text-[35px]">{{ location?.address }}, {{ location?.city }}, {{ location?.state }} {{ location?.zip }}</p>
                <div class="wrap wrap-large aspect-[1060/402] bg-gray-200 flex items-center justify-center !px-0 rounded-t-[4px]">
                    <google-map
                        :id="location?.id"
                        :markers="location?.map?.markers"
                        :options="location?.map?.options"
                        v-if="Object.keys(location?.map).length"
                    />
                </div>
                <ul class="bg-gray-800 flex flex-wrap gap-y-1 gap-x-8 p-4 rounded-b-[4px] text-white at1024:px-9">
                    <li  v-if="location?.pickup" class="flex items-center">
                        <BaseSvg name="CheckOutlined" class="mr-1 text-green shrink-0" aria-hidden="true" />
                        Pickup Available
                    </li>
                    <li class="flex items-center text-gray-400">
                        <BaseSvg name="ClockIcon" class="mr-1 shrink-0" aria-hidden="true" />
                        {{ location?.hours }}
                    </li>
                    <li class="basis-full mt-4 at768:basis-0 at768:ml-auto at768:mt-0">
                        <a
                            :href="location?.directions"
                            class="border-2 border-gray flex items-center justify-center py-1 px-6 rounded-full hover:border-white"
                        >
                            <BaseSvg name="MapIcon" class="mr-1" aria-hidden="true" />
                            <span class="font-semibold text-xs tracking-widest uppercase">Directions</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </section>
    <section>
        <div class="wrap wrap-large">
            <h4 class="font-bold leading-tight mb-[10px] text-[28px] text-center at1024:text-[35px]">An expanded warehouse, technical prowess, and accessibility make SECLOCK the logical choice on the West Coast.</h4>
        </div>
    </section>
    <section class="py-[60px] at1024:pb-32">
        <div class="wrap wrap-large flex flex-col gap-9 at1024:flex-row">
            <div class="bg-gray-800 flex flex-col p-9 text-white at1024:flex-1 at1024:p-[72px] at1024:pb-24 at1024:relative at1024:rounded-[4px]">
                <h4 class="font-bold leading-[1.2em] mb-4 text-[28px] at1024:text-[35px]">Already a SECLOCK customer?</h4>
                <p class="text-gray-300">Browse our inventory now.</p>
                <a href="/catalog/products" class="btn-white-on-red mt-7 justify-center text-xs w-full at768:ml-auto at768:w-auto at1024:absolute at1024:bottom-8 at1024:right-8">Log in</a>
            </div>
            <div class="bg-red flex flex-col p-9 text-white at1024:flex-1 at1024:p-[72px] at1024:pb-24 at1024:relative at1024:rounded-[4px]">
                <h4 class="font-bold leading-[1.2em] mb-4 text-[28px] at1024:text-[35px]">Not a SECLOCK customer?</h4>
                <p>Sign up to get access to the industry’s largest in-stock inventory.</p>
                <a href="/registration" class="btn-blue-on-gray mt-7 justify-center text-xs w-full at768:ml-auto at768:w-auto at1024:absolute at1024:bottom-8 at1024:right-8">Register today</a>
            </div>
        </div>
    </section>
    <Meta
        title="West Coast Expansion"
        description="Our new, much larger, facility is fully stocked with the industry’s premium brands."
    />
</template>

<script setup>
import config from "@/config";
import { BaseSvg, Meta, GoogleMap } from '@/Components';
import { ref, onMounted } from "vue";

let location = ref({map:{}});
onMounted(() => location.value = config.westcoast)
</script>
